module.exports = __webpack_public_path__ + "assets/img/social/telegram-icon.28cdadf89d59a0b93498e6a7148448e0.svg";